import { WorkbookSheetRowCellBorderLeft } from "@progress/kendo-angular-excel-export";
import { Company } from "./company.model";
import { Contact } from "./contact.model";
import { DropDownItem, IntDropDownItem, SimpleResponse, UserDD } from "./genericResponse.model";
import { Lead } from "./lead.model";
import { ClpUserFilterResponse, CustomSearchResponse } from "./report.model";

export interface Search {
    searchValue: string;
    searchText: string;
}

export interface SearchListResponse {
    searchList: Search[]
}

export interface ItemProperty {
    propertyName: string;
    PropertyValue: string;
}

export interface Item {   
    value: number;
    display: string;
    cLPCompanyID: number;
    sOrder: number;
    type: string;
    controlType: string;
    tableName: string;
    columnName: string;
    itemProperties: ItemProperty[];
    subItemData: Item[];
}

export interface SearchItem {
    value: string;
    displayValue: string;
    controlType: string;
    multiSelect: boolean;
    itemData: Item[];
    tableName: string;
    columnName: string;
    searchOperators: SearchOperatorsMap[];
}

export interface SearchOperatorsMap {
    operator: string;
    value: string;
    isDropDown: boolean;
    isMultiDropdown: boolean;
    isTextBox: boolean;
    col: string;
    isRange: boolean;
    isDate: boolean;
}

export interface SearchItemListResponse {
    searchItems: SearchItem[];
    savedQueries: keyValue[];
    clpUserFilter: ClpUserFilterResponse;
}

export interface GroupRows {
    groupId: number;
    groupRows: string;
}

export interface SearchQuery {
    rowId: number;
    cLPUserID: number;
    searchItem: string;
    operator: string;
    searchItemValue: string;
    groupBy: string;
    mainOperator: string;
    tableName: string;
    controlType: string;
    dtStart: Date;
    dtEnd: Date;
    strDtStart: string;
    strDtEnd: string;
}

export interface SearchQueryResponse {
    searchQueryList: SearchQuery[],
    group: Group[]
}


export interface keyValue extends SimpleResponse {
    key: number;
    value: string;
    isSelected: boolean;
}


export interface Group {
    items: number[];
    colSpan: number;
}

export interface HomeSearchResponse {
    contactList: Contact[];
    companyList: Company[];
    leadList: Lead[];
    documentList: number[];
    isContactList: boolean;
    isCompanyList: boolean;
    isLeadList: boolean;
    isDocumentList: boolean;
}

export interface HomeSearch {
    clpCompanyId: number;
    clpUserId: number;
    searchTxt: string;
    selectedOption: string;
    blnIsMine: boolean;
}


export interface WebFormDDResponse extends SimpleResponse {
    webFormDD: keyValue[];
}

export interface ContactSearchReq {
    lblLetter: string;
    txtSearch: string;
    ddFieldSelectedValue: string;
    //clpuserId: number;
    clpuserId: string;
    ddClass1Code: number;
    ddClass2Code: number;
    ddClass3Code: number;
    ddClass4Code: number;
    ddClass5Code: number;
    ddClass6Code: number;
    ddClass7Code: number;
    ddClass8Code: number;
    ddCheck1: string;
    ddCheck2: string;
    ddCheck3: string;
    ddCheck4: string;
    ddCheck5: string;
    ddCheck6: string;
    ddOutlookSync: string;
    ddCoClass1Code: number;
    ddCoClass2Code: number;
    ddCoClass3Code: number;
    ddCoClass4Code: number;
    ddCoClass5Code: number;
    ddCoClass6Code: number;
    ddCoClass7Code: number;
    ddCoClass8Code: number;
    ddCoCheck1: string;
    ddCoCheck2: string;
    ddCoCheck3: string;
    ddCoCheck4: string;
    lbCoTags: string[];
    lbCoTagSelected: string;
    lblTagSelected: string[];
    lbMetricsSelected: string[];
    ddMetricNames: string;
    ddMetricValues: string;
    txtMetricTextSearch: string;
    ddOpTags: string;
    buzzStart: string;
    buzzEnd: string;
    isShowScore: boolean;
    isEmailRequired: boolean;
    ddTxtMsgStatus: string;
    ddlStatusEmailInfo: number;
    ddlStatusEmailPromo: number;
    emailType: eEmailType;
    secClause: string;
    isMyPersonalContacts: boolean;
    useExtendedSearch: boolean;
    ddOpSearchText: string;
    searchId: number;
}

export enum eEmailType {
    None = 0,
    Informational = 1,
    Promotional = 2
}

export interface AddToSearchReq {
    ddAndOr: string;
    ddField: string;
    ddOpSearchText: string;
    txtSearch: string;
    ddValue: number[];
    cbValue: boolean;
    fromDate: string;
    toDate: string;
     
    lbTags: string[];
    
    lbMetricsSelected: string[];
    ddMetricNames: string;
    ddMetricValues: string;
    txtMetricTextSearch: string;
    ddOpTags: string;
    buzzStart: string;
    buzzEnd: string;
    ddEngagementType: string;
    ddEngagementOperator: string;
    ddEngagementValue: string;
    ddOpClass: string;

    isShowScore: boolean;
    isEmailRequired: boolean;
    
    emailType: eEmailType;
    secClause: string;
    useExtendedSearch: boolean;
    searchId: number;

    isEditText: boolean;
    isddValue: boolean;
    isEditCB: boolean;
    isEditDate: boolean;
    isBuzzScore: boolean;
    isMetricDetails: boolean;
    isTags: boolean;
    isEngagement: boolean;
}

export interface UserDDSearchReq {
    clpuserId: string[];
    ddTeam: string[];
    ddOffice: string[];
    ddOpUser: string;
    ddOpTeam: string;
    ddOpOffice: string;
}

export interface PowerSearchFilterResponse extends SimpleResponse {
    userList: UserDD[];
    fieldDD: DropDownItem[];
    metricList: string[];
    secClause: string;
    officeCodes: IntDropDownItem[];
    teamCodes: IntDropDownItem[];
    tagList: IntDropDownItem[];
}

export interface SearchClause {
    clauseText: string;
    sQLClause: string;
}

export interface PowerSearchRequest {
    searchClauseList: SearchClause[];
    userDDSearchReq: UserDDSearchReq;
    isEmailRequired: boolean;
    secClause: string;
    isUseExtendedSearch: boolean;
    havingScore: string;
    emailType: eEmailType;
}

export interface ContactSearchRequest {
    whereClause: string;
    orderBy: string;
    intRowCount: number;
    isExtended: boolean;
    isIncludeMetrics: boolean;
    havingScore: string;
}

export interface PowerSearchSaveRequest {
    searchClause: SearchClause[];
    customSearchResponse: CustomSearchResponse;
    clauseUser: string;
    userClauseText: string;
    secClause: string;
    isEditMode: boolean;

}
export interface PowerSearchRes extends SimpleResponse {
    searchClause: SearchClause[];
    customSearchResponse: CustomSearchResponse;
    clauseUser: string;
    userClauseText: string;
    secClause: string;
    havingScoreDisplay: string;
}




